export interface UserFeatureManagerConfig {
    featureName: string;
    i18nPrefix: string;
    /** When set, the header shows a back arrow that navigates here. */
    backRoute?: string;
}

/** Plan quantities at/above this sentinel are treated as "unlimited" (rendered as ∞ instead of a count). */
export const UNLIMITED_PLAN_THRESHOLD = 1000;

export function isUnlimitedQuantity(value: string | number | null | undefined): boolean {
    return value != null && Number(value) >= UNLIMITED_PLAN_THRESHOLD;
}

/**
 * - "active": subscribed and running.
 * - "canceling": cancellation requested, still usable/billed until endDate.
 * - "inactive": not subscribed (never, or cancellation already finalized).
 */
export type FeatureRowStatus = "active" | "canceling" | "inactive";

export interface UserFeatureStatus {
    id: number;
    /** Join key for billing-cycle data from the subscription module. */
    internalFeatureId: number;
    name: string;
    specialty?: string;
    subscribed: boolean;
    status: FeatureRowStatus;
    value?: string;
    startDate?: string;
    price?: number;
    /** End of the paid period (Vindi current_period.end_at) when cancelled — "vence em". */
    endDate?: string;
    /** BE-authoritative: true when the current admin may cancel this subscription (clinic-purchased or
     *  created by an admin). False when the professional self-hired it on their own customer. */
    allowCancel: boolean;
}

export interface FeatureSubscriptionStatus {
    internalFeatureId: number;
    /** Plan quantity (item Value) — restored as the quota on reactivation. */
    value?: string;
    /** Authoritative SubscriptionStatusCode name: "Active" | "Canceling" | "Canceled" | … */
    status?: string;
    endDate?: string;
    canceledAt?: string;
}

export type StatusFilter = "all" | "active" | "inactive";
